import { useMutation, useQuery } from "@tanstack/react-query";

import {
  getCheckOnboardingUrl,
  updateActivitiesUrl,
  CheckOutAndPayUrl,
} from "../utils/constants";
import { useApi } from "./useApi";

export type errorTypeWebsiteBuilder = {
  response: {
    data: { errorMessages: { messageAr: string; messageEn: string }[] };
  };
};

//Api Hooks
const useOnboarding = () => {
  const { apiPrivate } = useApi();

  const getCheckOnboardingApi = async () => {
    const { data } = await apiPrivate.get(`${getCheckOnboardingUrl}`);
    return data;
  };

  const updateActivitiesApi = async (body: any) => {
    const { data } = await apiPrivate.post(`${updateActivitiesUrl}`, body);
    return data;
  };
  const getCheckOutAndPayApi = async (body: any) => {
    const { data } = await apiPrivate.post(body);
    return data;
  };
  // Query

  const getCheckOnboardingQuery = () =>
    useQuery({
      enabled: true,
      queryKey: [getCheckOnboardingUrl],
      queryFn: ({ queryKey }) => getCheckOnboardingApi(),
    });

  // mutation
  const updateActivitiesMutate = ({
    onSuccess,
    onError,
  }: {
    onSuccess?: () => void;
    onError?: (error: errorTypeWebsiteBuilder) => void;
  }) =>
    useMutation({
      mutationFn: updateActivitiesApi,
      onSuccess,
      onError,
    });

  const CheckOutAndPayMutate = ({
    onSuccess,
    onError,
  }: {
    onSuccess?: () => void;
    onError?: (error: errorTypeWebsiteBuilder) => void;
  }) =>
    useMutation({
      mutationFn: getCheckOutAndPayApi,
      onSuccess,
      onError,
    });

  return {
    getCheckOnboardingQuery,
    updateActivitiesMutate,
    CheckOutAndPayMutate,
  };
};

export { useOnboarding };
